import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { StudyEntrySearchParams, StudyEntryService } from '../../../shared/study/service/study-entry.service';
import { BreedingMethodModalService } from '../../../shared/breeding-method/service/breeding-method-modal.service';
import { StudyEditorContext } from '../../study-editor.context';
import { Principal } from '../../../shared';
import {
    ADD_ENTRY_DETAILS_VARIABLES_PERMISSIONS,
    ADD_NEW_ENTRIES_PERMISSIONS,
    IMPORT_ENTRY_DETAILS_PERMISSIONS,
    MODIFY_COLUMNS_PERMISSIONS,
    MODIFY_ENTRY_DETAILS_VALUES_PERMISSIONS,
    REPLACE_GERMPLASM_PERMISSIONS,
    VIEW_GERMPLASM_DETAILS_PERMISSION
} from '../../../shared/auth/permissions';
import { VariableTypeEnum } from '../../../shared/ontology/variable-type.enum';
import { VariableDetails } from '../../../shared/ontology/model/variable-details';
import { ObservationVariable } from '../../../shared/model/observation-variable.model';
import { DatasetService } from '../../../shared/dataset/service/dataset.service';
import { StudyEntryModel } from '../../../shared/study/model/study-entry.model';
import { StudyEntryFilter, StudyEntryRequestModel } from '../../../shared/study/model/study-entry-request.model';
import { CellData, EditingDataMap } from '../../shared/study-inline-editor/study-inline-editor.component';
import { StudyEntryPropertyData } from '../../../shared/study/model/study-entry-property-data.model';
import { DataTypeEnum } from '../../../shared/ontology/data-type.enum';
import { ModalConfirmComponent } from '../../../shared/modal/modal-confirm.component';
import { StudyEntryObservationService } from '../../../shared/study/service/study-entry-observation';
import { AlertService } from '../../../shared/alert/alert.service';
import { DatasetVariable } from '../../../shared/study/model/dataset-variable';
import { DatasetModel } from '../../../shared/dataset/model/dataset.model';
import { ParamContext } from '../../../shared/service/param.context';
import { GermplasmListTreeTableComponent } from '../../../shared/tree/germplasm/germplasm-list-tree-table.component';
import { GermplasmDetailsPopupService } from '../../../germplasm-details/germplasm-details-popup.service';
import { InventoryDetailsPopupService } from '../../../germplasm-manager/inventory/details/inventory-details-popup.service';
import { Router } from '@angular/router';
import { JhiEventManager } from '../../../shared/core-utils';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AddNewEntriesComponent } from './add-new-entries/add-new-entries.component';
import { ImportEntryDetailsComponent } from '../../../study-manager/entry-details/import-entry-details.component';
import { EditEntryTypeComponent } from './edit-entry-type/edit-entry-type.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ColumnDataService } from '../../shared/services/column-data.service';
import { ColumnData } from '../../shared/models/column-data.model';
import { StudyEntryColumn } from '../../../shared/study/model/study-entry-column.model';
import { openSurvey } from '../../../shared/feedback/feedback-helper';
import { FeedbackFeatureEnum } from '../../../shared/feedback/feedback-feature.enum';
import { FeedbackService } from '../../../shared/feedback/service/feedback.service';
import { DateFormatEnum, formatDate } from '../../../shared/util/date-utils';
import { HELP_MANAGE_STUDIES_GERMPLASM, MAX_NAME_DISPLAY_SIZE } from '../../../app.constants';
import { COLUMN_SELECTOR_CHECKBOX_ID } from '../dataset/column-selector/column-selector.component';
import { GermplasmStudySourceService } from '../../../shared/germplasm/service/germplasm-study-source.service';
import { preventDefaultOnShiftKey } from '../../../field-management/utils';
import { GermplasmListUrlService } from '../../../shared/germplasm-list/service/germplasm-list.url.services';
import { SafeResourceUrl } from '@angular/platform-browser';
import {
    getStaticColumnLabelKey,
    STATIC_COLUMN_ACTIVE_LOT,
    STATIC_COLUMN_AVAILABLE, STATIC_COLUMN_BREEDING_METHOD_ABBR,
    STATIC_COLUMN_CROSS, STATIC_COLUMN_DESIGNATION, STATIC_COLUMN_ENTRY_NO, STATIC_COLUMN_ENTRY_TYPE, STATIC_COLUMN_FEMALE_PARENT_GID, STATIC_COLUMN_FEMALE_PARENT_NAME,
    STATIC_COLUMN_GID,
    STATIC_COLUMN_GROUPGID, STATIC_COLUMN_MALE_PARENT_GID, STATIC_COLUMN_MALE_PARENT_NAME,
    STATIC_COLUMN_UNIT
} from '../../../shared/util/static-columns-util';

@Component({
    selector: 'jhi-germplasm-checks',
    templateUrl: './germplasm-checks.component.html',
    styleUrls: ['./germplasm-checks.component.scss']
})
export class GermplasmChecksComponent implements OnInit, OnDestroy {

    protected readonly ADD_ENTRY_DETAILS_VARIABLES_PERMISSIONS = ADD_ENTRY_DETAILS_VARIABLES_PERMISSIONS;
    safeUrl: SafeResourceUrl;

    readonly MODIFY_COLUMNS_PERMISSIONS = MODIFY_COLUMNS_PERMISSIONS;

    readonly MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;
    readonly VariableTypeEnum = VariableTypeEnum;
    readonly DataTypeEnum = DataTypeEnum;
    readonly Math = Math;

    readonly STATIC_COLUMN_CHECKBOX = COLUMN_SELECTOR_CHECKBOX_ID;
    protected readonly STATIC_COLUMN_CROSS = STATIC_COLUMN_CROSS;
    protected readonly STATIC_COLUMN_ACTIVE_LOT = STATIC_COLUMN_ACTIVE_LOT;
    protected readonly STATIC_COLUMN_AVAILABLE = STATIC_COLUMN_AVAILABLE;
    protected readonly STATIC_COLUMN_UNIT = STATIC_COLUMN_UNIT;
    protected readonly STATIC_COLUMN_GROUPGID = STATIC_COLUMN_GROUPGID;
    protected readonly STATIC_COLUMN_GID = STATIC_COLUMN_GID;
    protected readonly STATIC_COLUMN_DESIGNATION = STATIC_COLUMN_DESIGNATION;
    protected readonly STATIC_COLUMN_MALE_PARENT_GID = STATIC_COLUMN_MALE_PARENT_GID;
    protected readonly STATIC_COLUMN_MALE_PARENT_NAME = STATIC_COLUMN_MALE_PARENT_NAME;
    protected readonly STATIC_COLUMN_FEMALE_PARENT_GID = STATIC_COLUMN_FEMALE_PARENT_GID;
    protected readonly STATIC_COLUMN_FEMALE_PARENT_NAME = STATIC_COLUMN_FEMALE_PARENT_NAME;
    protected readonly STATIC_COLUMN_BREEDING_METHOD_ABBR = STATIC_COLUMN_BREEDING_METHOD_ABBR;
    protected readonly HELP_MANAGE_STUDIES_GERMPLASM = HELP_MANAGE_STUDIES_GERMPLASM;
    protected readonly CREATE_STUDY_ENTRY_DETAILS_REQUIRED_FIELDS = [STATIC_COLUMN_ENTRY_NO, STATIC_COLUMN_ENTRY_TYPE];
    protected readonly preventDefaultOnShiftKey = preventDefaultOnShiftKey;
    protected readonly getStaticColumnLabelKey = getStaticColumnLabelKey;

    @ViewChild('p', { static: false }) columnFilterPopover: NgbPopover;

    entries: StudyEntryModel[] = [];
    editingData: EditingDataMap<StudyEntryPropertyData> = {};
    editingCell: CellData<StudyEntryPropertyData | null>;

    entryDetailVariables: ColumnData[] = [];
    selectedItems: Set<number> = new Set<number>();
    lastClickIndex: any;
    numberOfEntries = 0;
    numberOfFilteredEntries = 0;
    isLockedStudy = false;
    showImportListBrowser = true;
    showStudyEntriesTable = true;
    showClearList = false;
    showUpdateImportListButton = false;
    isCategoricalDescriptionView = false;
    generationLevel = 1;
    generationLevels = Array.from(Array(10).keys()).map(k => k + 1);

    germplasmDescriptorColumns: ColumnData[] = [];
    passportColumns: ColumnData[] = [];
    attributesColumns: ColumnData[] = [];
    namesColumns: ColumnData[] = [];
    displayedColumns: ColumnData[] = [];
    studyEntryColumnsTermIds: number[];

    currentPage = 1;
    pageSize = 50;

    activePopover?: NgbPopover;
    columnDataForFilter: ColumnData;

    plotDataset: DatasetModel;

    entrIdtoReplace: number;
    germplasmSelectorEventSubscriber: Subscription;

    columnDataService: ColumnDataService;

    isLoading = false;
    hasViewGermplasmDetailsPermission = false;

    constructor(
        private eventManager: JhiEventManager,
        private router: Router,
        private studyEntryService: StudyEntryService,
        private breedingMethodModalService: BreedingMethodModalService,
        public studyEditorContext: StudyEditorContext,
        public principal: Principal,
        private datasetService: DatasetService,
        private modalService: NgbModal,
        private studyEntryObservationService: StudyEntryObservationService,
        private alertService: AlertService,
        public paramContext: ParamContext,
        private activeModal: NgbActiveModal,
        protected germplasmDetailsPopupService: GermplasmDetailsPopupService,
        protected inventoryDetailsPopupService: InventoryDetailsPopupService,
        private translateService: TranslateService,
        private feedbackService: FeedbackService,
        private germplasmStudySourceService: GermplasmStudySourceService,
        public germplasmListUrlService: GermplasmListUrlService
    ) {
    }

    isReloadPending: boolean;
    reloadDelay: number = 800;
    reloadTimeout: any;

    isTableDataReloadPending: boolean;
    tableDataReloadTimeout: any;

    isSaveEntryTableColumnsPending: boolean;
    saveEntryTableColumnsTimeout: any;

    listId: number;
    listName: string;
    hasDifferences: boolean = false;

    /**
     * Efficiently reload table
     */
    scheduleReload(): void {
        if (this.isReloadPending) {
            // If a reload is already scheduled, reset the delay (debouncing)
            clearTimeout(this.reloadTimeout);
        } else {
            this.isReloadPending = true; // Indicate that a reload has been scheduled
        }

        // Schedule the reload after the specified delay
        this.reloadTimeout = setTimeout(() => {
            this.loadTable();
            this.isReloadPending = false; // Reset pending flag after reload
        }, this.reloadDelay);
    }

    /**
     * Efficiently reload table data
     */
    scheduleTableDataReload(pageIndex, pageSize): void {
        if (this.isTableDataReloadPending) {
            // If a reload is already scheduled, reset the delay (debouncing)
            clearTimeout(this.tableDataReloadTimeout);
        } else {
            this.isTableDataReloadPending = true; // Indicate that a reload has been scheduled
        }

        // Schedule the reload after the specified delay
        this.tableDataReloadTimeout = setTimeout(() => {
            this.loadTableData(pageIndex, pageSize);
            this.isTableDataReloadPending = false; // Reset pending flag after reload
        }, this.reloadDelay);
    }

    ngOnInit(): void {

        this.columnDataService = new ColumnDataService(ColumnDataService.GERMPLASM_CHECKS_KEY, String(this.studyEditorContext.studyDetails.id));
        this.hasViewGermplasmDetailsPermission = this.principal.hasAnyAuthorityDirect(VIEW_GERMPLASM_DETAILS_PERMISSION);

        openSurvey(FeedbackFeatureEnum.GERMPLASM_AND_CHECKS, this.feedbackService, this.modalService);
        this.loadTable();
        this.isLockedStudy = this.studyEditorContext.hasGeneratedDesign();
        this.plotDataset = this.studyEditorContext.getPlotDataset();
        this.loadStudyGermplasmListDetails();
    }

    loadTable(): void {
        this.isLoading = true;
        this.loadTableHeader().then(() => {
            this.loadTableData();
        });
    }

    loadTableHeader(): Promise<void> {
        return this.studyEntryService.getEntryTableColumns(this.studyEditorContext.studyDetails.id).toPromise().then(async columns => {
            const columnsFromResponse: ColumnData[] = columns.map(column => column as ColumnData);
            columnsFromResponse.forEach(column => {
                column.visible = true;
                column.selected = true;
                column.columnSelectorVisible = true;
            });

            // Add checkbox column and it should be the first column
            columnsFromResponse.unshift({
                alias: '',
                factor: true,
                name: '',
                termId: this.STATIC_COLUMN_CHECKBOX,
                displayName: '',
                visible: true,
                columnSelectorVisible: false,
                selected: true,
                variableTypeId: 0,
                id: 0,
                possibleValuesById: undefined,
                possibleValuesByName: undefined,
                enableFilterSorting: false,
                deletable: false,
                hidden: false,
                inputVariables: ''
            });

            // Get the list of available Study Germplasm Entry Columns. We need them to be displayed in the Column Selector.
            const columnsWithStudyEntryColumns = await this.loadStudyEntryColumns(columnsFromResponse);

            this.displayedColumns = this.columnDataService.processColumns(columnsWithStudyEntryColumns, this.displayedColumns);
            this.groupColumns(this.displayedColumns);
            this.displayedColumns = this.columnDataService.applyColumnsState();

            if (this.displayedColumns.every(column => column.sortingAsc === undefined)) {
                const entryNoColumn = this.displayedColumns.find(column => column.termId === STATIC_COLUMN_ENTRY_NO);
                if (entryNoColumn) {
                    entryNoColumn.sortingAsc = true;
                }
            };
        });
    }

    loadTableData(pageIndex = 0, pageSize = 50): void {
        const filter = this.getFilter();
        const searchData: StudyEntryRequestModel = {
            studyId: this.studyEditorContext.studyDetails.id,
            filter: filter
        };

        const searchParams: StudyEntrySearchParams = {
            page: pageIndex,
            size: pageSize,
            sort: this.getSort(),
            searchDTO: searchData,
            germplasmDescriptorIds: []
        };

        this.studyEntryService.getStudyEntries(this.studyEditorContext.studyDetails.id, searchParams).toPromise().then(
            (paginatedResponse) => {
                this.entries = paginatedResponse.data;
                this.numberOfEntries = paginatedResponse.totalCount;
                this.numberOfFilteredEntries = paginatedResponse.filteredCount;
                this.studyEditorContext.germplasmListExists = this.numberOfEntries > 0;
                this.studyEditorContext.studyDetails.numberOfEntries = this.numberOfEntries;
                this.isLoading = false;
            }).finally(() => {
            this.isLoading = false;
        });
    }

    private groupColumns(columnsData: ColumnData[]): void {

        this.germplasmDescriptorColumns = [];
        this.passportColumns = [];
        this.attributesColumns = [];
        this.namesColumns = [];
        this.entryDetailVariables = [];

        columnsData.forEach(column => {
            if (column.variableTypeId === VariableTypeEnum.GERMPLASM_DESCRIPTOR) {
                this.germplasmDescriptorColumns.push(column);
            } else if (column.variableTypeId === VariableTypeEnum.GERMPLASM_PASSPORT) {
                this.passportColumns.push(column);
            } else if (column.variableTypeId === VariableTypeEnum.GERMPLASM_ATTRIBUTE) {
                this.attributesColumns.push(column);
            } else if (column.variableTypeId === null && column.termId > 0) {
                this.namesColumns.push(column);
            } else if (column.variableTypeId === VariableTypeEnum.ENTRY_DETAIL) {
                this.entryDetailVariables.push(column);
            }
        });
    }

    async loadStudyEntryColumns(columns: ColumnData[]) {
        let columnsTemp = [...columns];

        const previousColumnsState = {};
        if (columnsTemp && columnsTemp.length) {
            columnsTemp.forEach(col => {
                previousColumnsState[col.termId] = {
                    visible: true,
                    selected: true,
                    columnSelectorVisible: true
                };
            });
        }

        const responseColumns = await this.studyEntryService.getStudyEntriesColumns(this.studyEditorContext.studyDetails.id).toPromise();
        this.studyEntryColumnsTermIds = responseColumns.map(column => column.id);

        // Build a map of new column data keyed by termId for O(1) lookup
        const newColumnsMap = new Map<number, ColumnData>();
        responseColumns.forEach((studyEntryColumn: StudyEntryColumn) => {
            const columnData: ColumnData = {
                displayName: studyEntryColumn.alias ? `${studyEntryColumn.alias} (${studyEntryColumn.name}) ` : studyEntryColumn.name,
                visible: previousColumnsState[studyEntryColumn.id]?.visible ?? studyEntryColumn.selected,
                columnSelectorVisible: true,
                selected: previousColumnsState[studyEntryColumn.id]?.selected ?? studyEntryColumn.selected,
                variableTypeId: studyEntryColumn.typeId,
                variableType: VariableTypeEnum[studyEntryColumn.typeId],
                id: studyEntryColumn.id,
                possibleValuesById: undefined,
                possibleValuesByName: undefined,
                enableFilterSorting: ![this.STATIC_COLUMN_FEMALE_PARENT_GID, this.STATIC_COLUMN_FEMALE_PARENT_NAME, this.STATIC_COLUMN_MALE_PARENT_GID, this.STATIC_COLUMN_MALE_PARENT_NAME].includes(studyEntryColumn.id),
                deletable: false,
                hidden: false,
                inputVariables: '',
                termId: studyEntryColumn.id,
                name: studyEntryColumn.name,
                alias: studyEntryColumn.alias
            };
            newColumnsMap.set(studyEntryColumn.id, columnData);
        });

        // Replace existing columns in-place to preserve order
        columnsTemp = columnsTemp.map(col =>
            newColumnsMap.has(col.termId) ? newColumnsMap.get(col.termId)! : col
        );

        // Find the first Entry Detail Column index, but ignore ENTRY_NO and ENTRY_TYPE columns
        const firstEntryDetailIndex = columnsTemp.findIndex(col => col.variableType === VariableTypeEnum[VariableTypeEnum.ENTRY_DETAIL] && col.termId !== STATIC_COLUMN_ENTRY_NO && col.termId !== STATIC_COLUMN_ENTRY_TYPE);
        // Append columns that didn't exist before, and insert them before the first Entry Detail column
        newColumnsMap.forEach((columnData, termId) => {
            if (!previousColumnsState[termId]) {
                if (firstEntryDetailIndex === -1) {
                    // If no entry detail column detected, just append at the end
                    columnsTemp.push(columnData);
                } else {
                    columnsTemp.splice(firstEntryDetailIndex, 0, columnData);
                }
            }
        });

        return columnsTemp;
    }

    toggleSelect($event, index: number, studyEntryModel: StudyEntryModel, checkbox = false) {
        if ($event.ctrlKey || $event.metaKey) {
            $event.preventDefault();
        }

        if (!checkbox) {
            $event.preventDefault();
        }

        if (!$event.ctrlKey && !$event.metaKey && !checkbox) {
            this.selectedItems.clear();
        }

        let items = [];
        if ($event.shiftKey) {
            const max = Math.max(this.lastClickIndex, index) + 1;
            const min = Math.min(this.lastClickIndex, index);
            items = this.entries.slice(min, max);
        } else {
            items = [studyEntryModel];
            this.lastClickIndex = index;
        }

        const isClickedItemSelected = this.selectedItems.has(studyEntryModel.entryId);
        for (const item of items) {
            if (isClickedItemSelected) {
                this.selectedItems.delete(item.entryId);
            } else {
                this.selectedItems.add(item.entryId);
            }
        }

    }

    isSelected(entryId: number): boolean {
        return this.selectedItems.has(entryId);
    }

    getFilter(): StudyEntryFilter {
        return {
            entryNumbers: [],
            entryIds: [],
            filteredValues: this.displayedColumns.reduce((map, column) => {
                column.isFiltered = false;

                if (this.isTextFilter(column)) {
                    return map;
                }

                if (column.possibleValues) {
                    const selectedValues = column.possibleValues
                        .filter(value => value.isSelectedInFilters)
                        .map(value => value.name);

                    if (selectedValues.length > 0) {
                        map[column.termId] = selectedValues;
                        column.isFiltered = true;
                    } else if (column.query) {
                        map[column.termId] = [column.query];
                        column.isFiltered = true;
                    }
                } else if (column.query) {
                    if (column.dataType === 'Date') {
                        map[String(column.termId)] = [formatDate(column.query, DateFormatEnum.ISO_8601_BASIC)];
                    } else {
                        map[String(column.termId)] = [column.query];
                    }
                }

                return map;
            }, {} as Map<string, string[]>),
            filteredTextValues: this.displayedColumns.reduce((map, column) => {
                if (!this.isTextFilter(column)) {
                    return map;
                }
                if (column.query) {
                    map[column.termId] = column.query;
                    column.isFiltered = true;
                }
                return map;
            }, {} as Map<string, string>),
            variableTypeMap: this.displayedColumns.reduce((map, column) => {
                map[column.termId] = column.variableType;
                return map;
            }, {} as Map<string, string>),
            preFilteredGids: []
        };
    }

    isTextFilter(column: ColumnData): boolean {
        // Factors like GID, GROUPGID have 'Germplasm List' datatype but they should be treated as numeric
        if (column.termId === this.STATIC_COLUMN_GID || column.termId === this.STATIC_COLUMN_GROUPGID) {
            return false;
        }

        // FEMALE_PARENR_GID and FEMALE_PARENT_GID are also numeric but should be treated as text
        if (column.termId === this.STATIC_COLUMN_FEMALE_PARENT_GID || column.termId === this.STATIC_COLUMN_MALE_PARENT_GID ||
            column.termId === this.STATIC_COLUMN_FEMALE_PARENT_NAME || column.termId === this.STATIC_COLUMN_MALE_PARENT_NAME) {
            return true;
        }

        if (column.dataTypeCode === 'C' || column.dataTypeCode === 'N'
            || column.dataTypeCode === 'D') {
            return false;
        }

        return true;
    }

    hasAnyAuthority(permissions: string[]): boolean {
        return this.principal.hasAnyAuthorityDirect(permissions);
    }

    openBreedingMethodModal(methodId: number): void {
        this.breedingMethodModalService.openBreedingMethodModal(methodId, null);
    }

    onPageChange(page: number): void {
        this.currentPage = page;
        this.scheduleTableDataReload((page - 1), this.pageSize);
    }

    onSelectAll(column: ColumnData): void {
        if (column.possibleValues) {
            column.possibleValues.forEach(value => {
                value.isSelectedInFilters = column.isSelectAll;
            });
        }
    }

    onSelectOption(column: ColumnData, option: any): void {
        if (!option.isSelectedInFilters) {
            column.isSelectAll = false;
        }
    }

    getFilteredOptions(column: ColumnData): any[] {
        if (!column.possibleValues) {
            return [];
        }
        return column.possibleValues.filter(option => {
            if (!column.query) {
                return true;
            }
            return option.name.toLowerCase().includes(column.query.toLowerCase());
        });
    }

    applyFilter(column: ColumnData): void {
        this.scheduleTableDataReload(0, this.pageSize);
        if (this.activePopover) {
            this.activePopover.close();
        }
    }

    resetFilter(column: ColumnData): void {
        column.query = '';
        column.sortingAsc = null;
        if (column.possibleValues) {
            column.possibleValues.forEach(value => {
                value.isSelectedInFilters = false;
            });
            column.isSelectAll = false;
        }
        this.scheduleTableDataReload(0, this.pageSize);
    }

    getCellClass(entry: StudyEntryModel, column: ColumnData): string {
        const property = entry.properties[column.termId];
        if (!property) {
            return '';
        }

        const classes = ['entry-details'];

        if (this.isColumnEditable(column)) {
            classes.push('editable');
        }

        if (property.status === 'MANUALLY_EDITED') {
            classes.push('manually-edited-value');
        } else if (property.status === 'OUT_OF_SYNC') {
            classes.push('out-of-sync-value');
        }

        return classes.join(' ');
    }

    isColumnEditable(column: ColumnData): boolean {

        if (column.termId === STATIC_COLUMN_ENTRY_NO) {
            return false;
        }

        // Only ENTRY DETAIL variables are editable
        return (column.termId === STATIC_COLUMN_ENTRY_TYPE || column?.variableType?.toString() === VariableTypeEnum[VariableTypeEnum.ENTRY_DETAIL]) &&
            this.hasAnyAuthority(MODIFY_ENTRY_DETAILS_VALUES_PERMISSIONS) &&
            (!column.systemVariable || (column.systemVariable && !this.studyEditorContext.hasExperimentalDesign()));
    }

    getCellValue(entry: StudyEntryModel, column: ColumnData): string {
        if (!entry?.properties || !column?.termId) {
            return '';
        }

        const property = entry.properties[column.termId];
        if (!property?.value) {
            return '';
        }

        return property.value;
    }

    saveEntryTableColumns() {
        if (this.isSaveEntryTableColumnsPending) {
            // If a reload is already scheduled, reset the delay (debouncing)
            clearTimeout(this.saveEntryTableColumnsTimeout);
        } else {
            this.isSaveEntryTableColumnsPending = true; // Indicate that a reload has been scheduled
        }

        // Schedule the reload after the specified delay
        this.saveEntryTableColumnsTimeout = setTimeout(async () => {
            const germplasmEntryColumns = this.displayedColumns.filter(column => {
                return (column.variableTypeId === VariableTypeEnum.GERMPLASM_DESCRIPTOR ||
                    column.variableTypeId === VariableTypeEnum.GERMPLASM_PASSPORT ||
                    column.variableTypeId === VariableTypeEnum.GERMPLASM_ATTRIBUTE ||
                    column.variableTypeId === null) && column.termId > 0;
            });

            const selectedPropertyIds = germplasmEntryColumns
                .filter(column => column.selected && column.variableTypeId !== null && column.termId > 0)
                .map(column => column.termId);

            const selectedNameTypeIds = germplasmEntryColumns
                .filter(column => column.selected && column.variableTypeId === null && column.termId > 0)
                .map(column => column.termId);

            await this.datasetService.updateDatasetProperties(this.studyEditorContext.studyDetails.id, {
                variableIds: selectedPropertyIds,
                nameTypeIds: selectedNameTypeIds
            }).toPromise();

            // When columns are added/removed from Germplasm Entry table , we should delete the Order State of Study Dataset (Observations and SubObs) Columns
            // To ensure that gemrplasm entry columns are not appended at the end of the table
            ColumnDataService.deleteColumnsStateByStorageKey(ColumnDataService.storageKeyPrefixOrderState, ColumnDataService.STUDY_DATASET_KEY);

            this.scheduleReload();
            this.isSaveEntryTableColumnsPending = false; // Reset pending flag after reload
        }, this.reloadDelay);

    }

    async resetEntryTableColumns(): Promise<void> {

        this.displayedColumns.forEach(column => {
            if (this.studyEntryColumnsTermIds.includes(column.termId)) {
                column.selected = false;
                column.visible = false;
            } else {
                column.selected = true;
                column.visible = true;
            }
        });

        await this.datasetService.updateDatasetProperties(this.studyEditorContext.studyDetails.id, {
            variableIds: [],
            nameTypeIds: []
        }).toPromise();

        // When Germplasm Entry table is reset, we should delete the Order State of Study Dataset (Observations and SubObs) Columns
        // To ensure that gemrplasm entry columns are not appended at the end of the table
        ColumnDataService.deleteColumnsStateByStorageKey(ColumnDataService.storageKeyPrefixOrderState, ColumnDataService.STUDY_DATASET_KEY);

        this.scheduleReload();
    }

    toggleShowCategoricalDescription(): void {
        this.isCategoricalDescriptionView = !this.isCategoricalDescriptionView;
    }

    browseList() {
        const modalRef = this.modalService.open(GermplasmListTreeTableComponent as Component, { size: 'xl', backdrop: 'static' });
        modalRef.componentInstance.selectionMode = 'single';
        modalRef.componentInstance.isFolderSelectionMode = false;
        modalRef.result.then((germplasmLists) => {
            if (germplasmLists && germplasmLists.length === 0) {
                this.alertService.error('select.list.error');
            } else {
                if (germplasmLists && germplasmLists.length > 0) {
                    const listId = germplasmLists[0].id;
                    this.studyEntryService.saveStudyEntriesList(this.studyEditorContext.studyDetails.id, listId).toPromise().then(async() => {
                        this.studyEditorContext.germplasmListExists = true;
                        this.loadStudyGermplasmListDetails();
                        this.scheduleReload();
                    }
                    );
                }
            }
            this.activeModal.close();
        }, () => this.activeModal.dismiss());
    }

    loadStudyGermplasmListDetails() {
        this.studyEntryService.getStudyGermplasmListDetails(this.studyEditorContext.studyDetails.id).subscribe(studyListDetailsDTO => {
            if (studyListDetailsDTO != null) {
                this.listName = studyListDetailsDTO.germplasmListName;
                this.listId = studyListDetailsDTO.germplasmListId;
                this.hasDifferences = Boolean(studyListDetailsDTO.hasGermplasmOrEntriesDifferences);
                this.safeUrl = this.germplasmListUrlService.getUrl(this.listId, this.listName);

            } else {
                this.listName = null;
                this.listId = null;
                this.hasDifferences = false;
                this.safeUrl = null;
            }
        });
    }

    updateModifyList(): void {
        this.showImportListBrowser = true;
        this.showUpdateImportListButton = false;
    }

    resetStudyEntries(): void {
        // Implement clear list functionality
    }

    getColumnClass(column: ColumnData) {
        let className = 'default ';
        if (this.isColumnEditable(column)) {
            className += 'entry-detail editable';
        }
        return className;
    }

    selectEditableCell(entry: StudyEntryModel, column: ColumnData, row: number, col: number, $event?): void {

        if (!this.isColumnEditable(column)) {
            return;
        }

        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }

        // If the clicked cell is already editing, cancel the event.
        if (this.editingCell && this.editingCell.row === row && this.editingCell.col === col) {
            return;
        }

        this.onCellBlur(column, row, col);

        this.clearSelected();

        if (this.editingCell) {
            this.editingCell.isEditing = false;
        }

        const cellData: CellData<StudyEntryPropertyData> = {
            isEditing: true,
            model: entry.properties[column.termId],
            row: row,
            col: col,
            previousValue: entry.properties[column.termId]?.value,
            hasError: false
        };
        cellData.model.entryId = entry.entryId;

        this.setCellData(row, col, cellData);
        this.editingCell = cellData;
    }

    checkVariableHasMeasurementData(deleteVariables: ObservationVariable[]): Promise<boolean> {
        if (deleteVariables.length === 0) {
            return Promise.resolve(false); // No variables to delete, return false
        }

        const variablesToDelete: number[] = deleteVariables.map(variable => variable.termId);

        // Asynchronous process to check the count of observations
        return this.studyEntryObservationService.countObservationsByVariables(this.studyEditorContext.studyDetails.id, variablesToDelete)
            .toPromise()
            .then(response => {
                const count = parseInt(response.headers.get('X-Total-Count'), 10); // First check the count
                if (count > 0) {
                    // Show confirmation modal and handle user choice
                    const modalRef = this.modalService.open(ModalConfirmComponent);
                    modalRef.componentInstance.title = this.translateService.instant('study-editor.germplasm-checks.confirmation');
                    modalRef.componentInstance.message = this.translateService.instant('study-editor.germplasm-checks.confirmation.message');

                    return modalRef.result
                        .then(() => true) // User confirms (true)
                        .catch(() => false); // User cancels (false)
                } else {
                    // No observations, resolve as true
                    return true;
                }
            })
            .catch(error => {
                console.error('Error checking variable measurement data:', error);
                return true; // Handle error case, return true as a fallback
            });
    }

    async addVariable(variable: VariableDetails): Promise<void> {
        if (this.plotDataset) {
            const datasetVariable: DatasetVariable = {
                variableTypeId: VariableTypeEnum.ENTRY_DETAIL,
                variableId: parseInt(variable.id, 10),
                studyAlias: variable.alias || variable.name
            };

            await this.datasetService.addEntryDetails(this.studyEditorContext.studyDetails.id, this.plotDataset.datasetId, datasetVariable).toPromise();

            // When columns are added/removed from Germplasm Entry table , we should delete the Order State of Study Dataset (Observations and SubObs) Columns
            // To ensure that gemrplasm entry columns are not appended at the end of the table
            ColumnDataService.deleteColumnsStateByStorageKey(ColumnDataService.storageKeyPrefixOrderState, ColumnDataService.STUDY_DATASET_KEY);

            // Schedule reload instead of immediate reload
            this.scheduleReload();
        }
    }

    async removeVariables(variables: ObservationVariable[]) {
        try {
            const shouldDelete = await this.checkVariableHasMeasurementData(variables);
            if (shouldDelete) {
                const variablesToDelete: number[] = variables.map(variable => variable.termId);
                await this.datasetService.removeEntryDetails(this.studyEditorContext.studyDetails.id, this.plotDataset.datasetId, variablesToDelete).toPromise();
            }

            // When columns are added/removed from Germplasm Entry table , we should delete the Order State of Study Dataset (Observations and SubObs) Columns
            // To ensure that gemrplasm entry columns are not appended at the end of the table
            ColumnDataService.deleteColumnsStateByStorageKey(ColumnDataService.storageKeyPrefixOrderState, ColumnDataService.STUDY_DATASET_KEY);

        } catch (errorResponse) {
        }

        // Schedule reload instead of immediate reload
        this.scheduleReload();
    }

    getSort(): string {

        const sort = this.displayedColumns.reduce((sort, column) => {
            if (column.sortingAsc !== null && column.sortingAsc !== undefined) {
                let sort: string = column.termId + '';
                if (column.variableTypeId === VariableTypeEnum.GERMPLASM_PASSPORT ||
                    column.variableTypeId === VariableTypeEnum.GERMPLASM_ATTRIBUTE) {
                    sort = 'VARIABLE_' + sort;
                } else if (column.variableTypeId === null && column.termId > 0) {
                    sort = 'NAME_' + sort;
                }
                return sort + ',' + (column.sortingAsc ? 'asc' : 'desc');
            }
            return sort;
        }, '');

        return sort;
    }

    sortColumn(column: ColumnData, ascending: boolean): void {

        // Clear sorting state for all displayed columns to ensure only one column can be sorted at a time
        this.resetSortingsOfDisplayedColumns();

        column.sortingAsc = ascending;
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    filterByColumn(column: ColumnData) {
        this.clearSelected();
        column.isFiltered = true;
        this.columnFilterPopover.close();
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    resetFilterByColumn(column: ColumnData) {
        this.clearSelected();
        column.isFiltered = false;
        column.query = '';
        column.sortingAsc = null;
        column.possibleValues?.forEach(value => {
            value.isSelectedInFilters = false;
        });
        column.isSelectAll = false;
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    resetSortingsOfDisplayedColumns() {
        this.displayedColumns.forEach(column => {
            column.sortingAsc = null;
        });
    }

    filterSelectAll(column: ColumnData, isSelectAll: boolean) {
        if (column.possibleValues) {
            column.possibleValues.forEach(value => {
                value.isSelectedInFilters = isSelectAll;
            });
        }
    }

    filterSelectOption(isSelectedInFilters: any) {

    }

    showColumnFilterPopover(column: ColumnData, p: NgbPopover) {
        this.columnDataForFilter = column;
        p.open({
            column: column
        });
    }

    onPageSizeChange($event: Event) {
        this.scheduleTableDataReload((this.currentPage - 1), this.pageSize);
    }

    areColumnsVisible(columns: ColumnData[]): boolean {
        return columns.filter((column) => column.visible).length > 0;
    }

    getCellData(row: number, col: number): CellData<StudyEntryPropertyData> | null {
        try {
            // Input validation
            if (row < 0 || col < 0) {
                return null;
            }

            // Check if row exists
            const rowData = this.editingData[row];
            if (!rowData) {
                return null;
            }

            // Check if cell exists in row
            const cellData = rowData[col];
            if (!cellData) {
                return null;
            }

            return cellData;
        } catch (error) {
            console.error(`Error getting cell data for row ${row}, col ${col}:`, error);
            return null;
        }
    }

    // Helper method to set cell data
    setCellData(row: number, col: number, data: Partial<CellData<StudyEntryPropertyData>>): void {
        if (!this.editingData[row]) {
            this.editingData[row] = {};
        }

        this.editingData[row][col] = {
            ...this.editingData[row][col],
            ...data,
            row,
            col
        };
    }

    // Helper method to check if cell exists
    hasCellData(row: number, col: number): boolean {
        return !!(this.editingData[row]?.[col]);
    }

    // Helper method to clear cell data
    clearCellData(row: number, col: number): void {
        if (this.editingData[row]) {
            delete this.editingData[row][col];

            // Clean up empty rows
            if (Object.keys(this.editingData[row]).length === 0) {
                delete this.editingData[row];
            }
        }
    }

    variableDataTypeIs(variable: ColumnData, type: DataTypeEnum): boolean {
        if (variable.variableType && variable.variableType.toString() === VariableTypeEnum[VariableTypeEnum.STUDY_DETAIL]) {
            return variable.dataType && variable.dataType.valueOf() === DataTypeEnum[type];
        }
        return false;
    }

    onCellBlur(column: ColumnData, row: number, col: number) {
        this.updateStudyEntryObservation(column);
        this.resetSelected();
    }

    resetSelected() {
        if (this.editingCell) {
            this.editingCell.isEditing = false;
            this.editingCell = null;
        }
    }

    onCellKeyDown(event: KeyboardEvent, column: ColumnData, row: number, col: number) {
        switch (event.key) {
        case 'Enter':
        case 'Escape':
            event.preventDefault();
            this.onCellBlur(column, row, col);
            break;
        case 'Tab':
            event.preventDefault();
            const nextRow = row + (event.shiftKey ? -1 : 1);
            if (nextRow >= 0 && nextRow < this.entries.length) {
                this.onCellBlur(column, row, col);
                this.selectEditableCell(this.entries[nextRow], column, nextRow, col);
            }
            break;
        case 'ArrowRight':
            event.preventDefault();
            // Find next editable column
            for (let nextCol = col + 1; nextCol < this.displayedColumns.length; nextCol++) {
                if (this.isColumnEditable(this.displayedColumns[nextCol])) {
                    this.onCellBlur(column, row, col);
                    this.selectEditableCell(this.entries[row], this.displayedColumns[nextCol], row, nextCol);
                    break;
                }
            }
            break;
        case 'ArrowLeft':
            event.preventDefault();
            // Find previous editable column
            for (let prevCol = col - 1; prevCol >= 0; prevCol--) {
                if (this.isColumnEditable(this.displayedColumns[prevCol])) {
                    this.onCellBlur(column, row, col);
                    this.selectEditableCell(this.entries[row], this.displayedColumns[prevCol], row, prevCol);
                    break;
                }
            }
            break;
        case 'ArrowUp':
            if (row > 0) {
                event.preventDefault();
                this.onCellBlur(column, row, col);
                this.selectEditableCell(this.entries[row - 1], column, row - 1, col);
            }
            break;
        case 'ArrowDown':
            if (row < this.entries.length - 1) {
                event.preventDefault();
                this.onCellBlur(column, row, col);
                this.selectEditableCell(this.entries[row + 1], column, row + 1, col);
            }
            break;
        }
    }

    trackRowsById(studyEntryModel: StudyEntryModel) {
        return studyEntryModel.guid;
    }

    trackColumnsById(column: ColumnData) {
        return column.id;
    }

    async updateStudyEntryObservation(column: ColumnData): Promise<void> {
        if (!this.editingCell) {
            return;
        }

        const currentCell = this.editingCell;
        const property: StudyEntryPropertyData = currentCell.model;
        const value = currentCell.model.value;
        const previousValue = currentCell.previousValue;
        const row = currentCell.row;
        const col = currentCell.col;

        try {
            if (!property) {
                return;
            }

            // Do not update if value hasn't changed.
            if (previousValue === value) {
                return;
            }

            if (this.validateValue(value)) {
                this.alertService.error('study-editor.study-dataset.error.invalid-value');
                currentCell.model.value = previousValue;
                return;
            }

            const doContinue = await this.confirmOutOfBoundData(value, column);
            if (!doContinue) {
                property.value = previousValue;
                return;
            }

            const observationData = {
                stockId: property.entryId,
                variableId: column.termId,
                value: value,
                categoricalValueId: this.getCategoricalValueId(value, column)
            };

            if (property.studyEntryPropertyId) {
                await this.studyEntryObservationService
                    .updateObservation(this.studyEditorContext.studyDetails.id, observationData)
                    .toPromise();
            } else if (value) {
                const studyEntryPropertyId = await this.studyEntryObservationService
                    .addObservation(this.studyEditorContext.studyDetails.id, observationData)
                    .toPromise();
                property.studyEntryPropertyId = studyEntryPropertyId;
            }
        } catch (error) {
            // Handle any errors that might occur
            property.value = previousValue;
            this.getCellData(row, col).hasError = true;
            throw error;
        }
    }

    private confirmOutOfBoundData(cellDataValue: string, columnData: ColumnData): Promise<boolean> {
        const invalid = this.validateDataOutOfRange(cellDataValue, columnData);

        if (invalid) {
            // Open confirmation modal and return its promise
            const modalRef = this.modalService.open(ModalConfirmComponent);
            modalRef.componentInstance.title = this.translateService.instant('study-editor.study-dataset.confirm-out-of-bound.title');
            modalRef.componentInstance.message = this.translateService.instant('study-editor.germplasm-checks.please.confirm');
            modalRef.componentInstance.confirmButtonText = this.translateService.instant('continue');
            modalRef.componentInstance.cancelButtonText = this.translateService.instant('cancel');

            return modalRef.result
                .then(() => true)
                .catch(() => false);
        }

        return Promise.resolve(true);

    }

    private validateValue(value) {
        const invalidChars = /[<>?|%]/;
        return invalidChars.test(value);
    }

    private validateDataOutOfRange(cellDataValue: string, columnData: ColumnData) {
        let invalid = false;

        let value = cellDataValue;
        let minVal = columnData.minRange;
        let maxVal = columnData.maxRange;

        if (minVal && maxVal) {
            invalid = this.validateNumericRange(minVal, maxVal, value, invalid);
        }
        invalid = this.validateCategoricalValues(columnData, cellDataValue, invalid);
        return invalid;
    }

    private validateNumericRange(minVal: number, maxVal: number, value: string, invalid: boolean) {
        if (parseFloat(value) < (minVal) || parseFloat(value) > (maxVal)) {
            invalid = true;
        }
        return invalid;
    }

    private validateCategoricalValues(columnData: ColumnData, cellDataValue: string, invalid: boolean) {
        if (columnData.possibleValues
            && columnData.possibleValues.find((possibleValue) => {
                return possibleValue.name === cellDataValue;
            }) === undefined
            && cellDataValue !== 'missing') {

            invalid = true;
        }
        return invalid;
    }

    private getCategoricalValueId(value: string, columnData: ColumnData): number | null {
        if (columnData.possibleValues && value !== 'missing') {
            let possibleValue = columnData.possibleValues.find((possibleValue) => {
                return possibleValue.name === value;
            });
            if (possibleValue) {
                return possibleValue.id;
            }
        }
        return null;
    }

    async replaceGermplasm() {
        if (this.selectedItems && this.selectedItems.size === 1) {
            const selectedEntryId = this.selectedItems.values().next().value;
            this.entrIdtoReplace = selectedEntryId;

            // Replace Germplasm is not allowed if the study already has crosses and selections
            const germplasmStudySources = await this.germplasmStudySourceService.searchGermplasmStudySources(this.studyEditorContext.studyId, {
                studyId: this.studyEditorContext.studyId,
                filter: null
            }, 0, 1, null).toPromise();
            if (germplasmStudySources.data.length > 0) {
                this.alertService.error('study-editor.germplasm-checks.replace.germplasm.study.has.crosses.or.selections');
                return;
            }

            if (this.studyEditorContext.hasGeneratedDesign()) {
                const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
                confirmModalRef.componentInstance.message = this.translateService.instant('study-editor.germplasm-checks.replace.germplasm.warning.for.generated.design');
                confirmModalRef.result.then(() => {
                    this.openGermplasmSelector(false);
                }, () => confirmModalRef.dismiss());
            } else {
                this.openGermplasmSelector(false);
            }
        } else if (this.selectedItems && this.selectedItems.size > 1) {
            this.alertService.error('study-editor.germplasm-checks.replace.germplasm.select.only.one.entry');
        } else if (!this.selectedItems || this.selectedItems.size === 0) {
            this.alertService.error('study-editor.germplasm-checks.replace.germplasm.select.entry');
        }
    }

    setEntryType() {
        if (this.selectedItems.size === 0) {
            this.alertService.error('study-editor.germplasm-checks.set.entry.type.select.entry');
        } else {
            if (!this.studyEditorContext.hasGeneratedDesign()) {
                const studyId = this.studyEditorContext.studyDetails.id;
                const modalRef = this.modalService.open(EditEntryTypeComponent as Component);
                modalRef.result.then((selectedEntryTypeId) => {
                    this.studyEntryService.updateStudyEntriesProperty(studyId, Array.from(this.selectedItems), 8255, selectedEntryTypeId).toPromise().then(() => {
                        this.alertService.success('study-editor.germplasm-checks.set.entry.type.success');
                        this.scheduleReload();
                    });
                });
            }
        }
    }

    addNewEntries() {

        if (this.studyEditorContext.hasGeneratedDesign()) {
            const confirmModalRef = this.modalService.open(ModalConfirmComponent as Component);
            confirmModalRef.componentInstance.message = this.translateService.instant('study-editor.germplasm-checks.add.new.entries.warning.for.generated.design');
            confirmModalRef.result.then(() => {
                this.showAddNewEntriesModal();
            }, () => confirmModalRef.dismiss());
        } else {
            this.showAddNewEntriesModal();
        }
    }

    showAddNewEntriesModal() {
        const modalRef = this.modalService.open(AddNewEntriesComponent as Component, { size: 'md', backdrop: 'static' });
        modalRef.result.then((result) => {
            this.scheduleReload();
            this.loadStudyGermplasmListDetails();
        });
    }

    importEntryDetails() {
        const studyId = this.studyEditorContext.studyDetails.id;
        const modalRef = this.modalService.open(ImportEntryDetailsComponent as Component, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.studyId = studyId;
        modalRef.componentInstance.hasGeneratedDesign = this.studyEditorContext.hasGeneratedDesign();
        modalRef.result.then((result) => {
            this.scheduleReload();
        });
    }

    showCrossExpansionPopover(p: NgbPopover) {
        p.open();
    }

    fillWithCrossExpansion(generationLevel: string) {
        this.studyEntryService.fillWithCrossExpansion(this.studyEditorContext.studyDetails.id, generationLevel).toPromise().then(response => {
            this.scheduleReload();
        });
    };

    changeList() {
        this.studyEntryService.deleteEntries(this.studyEditorContext.studyDetails.id).toPromise().then(async() => {
            this.studyEditorContext.germplasmListExists = false;
            this.studyEditorContext.studyDetails.numberOfEntries = 0;
            this.entries = [];
            this.scheduleReload();
            this.browseList();
        });
    }

    openGermplasmDetails(gid: number) {
        this.germplasmDetailsPopupService.open(gid);
    }

    openInventoryDetails(gid: number) {
        this.inventoryDetailsPopupService.open(gid);
    }

    openGermplasmSelector(selectMultiple: boolean): void {
        this.registerGermplasmSelectorSelected();
        this.router.navigate(['/', { outlets: { popup: 'germplasm-selector-dialog' } }], {
            queryParamsHandling: 'merge',
            queryParams: {
                cropName: this.paramContext.cropName,
                loggedInUserId: this.paramContext.loggedInUserId,
                programUUID: this.paramContext.programUUID,
                selectMultiple
            }
        });
    }

    registerGermplasmSelectorSelected() {
        this.germplasmSelectorEventSubscriber = this.eventManager.subscribe('germplasmSelectorSelected', (event) => {
            if (event.name === 'germplasmSelectorSelected') {
                const studyId = this.studyEditorContext.studyDetails.id;
                const replacementGid = Number(event.content);
                this.studyEntryService.replaceStudyGermplasm(studyId, this.entrIdtoReplace, replacementGid).toPromise().then(response => {
                    this.alertService.success('study-editor.germplasm-checks.replace.germplasm.successful');
                    this.scheduleReload();
                    this.loadStudyGermplasmListDetails();
                });
                if (this.germplasmSelectorEventSubscriber) {
                    this.eventManager.destroy(this.germplasmSelectorEventSubscriber);
                }
            } else {

            }
        });
    }

    ngOnDestroy(): void {
        if (this.germplasmSelectorEventSubscriber) {
            this.eventManager.destroy(this.germplasmSelectorEventSubscriber);
        }
    }

    clearSelected() {
        this.selectedItems.clear();
    }

    handleContextMenu(event: MouseEvent) {
        // Check if the right-click originated from an input or its label
        if (event.target instanceof HTMLInputElement ||
            event.target instanceof HTMLLabelElement ||
            (event.target instanceof HTMLElement && event.target.closest('input'))) {
            // Allow default context menu for inputs
            return;
        }

        // Prevent default context menu for the rest of the row
        event.preventDefault();

    }

    dropColumn(event: CdkDragDrop<any[]>) {
        // Get indexes of selected columns only
        const selectedColumns = this.displayedColumns.filter(col => col.selected);
        const fromIndex = this.displayedColumns.findIndex(col => col === selectedColumns[event.previousIndex]);
        const toIndex = this.displayedColumns.findIndex(col => col === selectedColumns[event.currentIndex]);

        if (fromIndex !== -1 && toIndex !== -1) {
            moveItemInArray(this.displayedColumns, fromIndex, toIndex);
            this.columnDataService.saveColumnsState();
        }
    }

    onColumnSelectorDeselectedAll() {
        this.displayedColumns.forEach(column => {
            if (column.visible) {
                column.selected = false;
            }
        });
        this.saveEntryTableColumns();
    }

    onColumnSelectorSelectedAll() {
        this.displayedColumns.forEach(column => {
            if (column.visible) {
                column.selected = true;
            }
        });
        this.saveEntryTableColumns();
    }

    onColumnSelectoChange(column: ColumnData) {
        if (column) {
            column.visible = column.selected;
        }
        this.saveEntryTableColumns();
    }

    onColumnSelectorReset() {
        this.resetEntryTableColumns();
    }

    clearFilters() {
        this.clearSelected();
        this.displayedColumns.forEach(column => {
            this.resetFilter(column);
        });
    }


    showReplaceGermplasmAction() {
        return this.studyEditorContext.germplasmListExists && this.principal.hasAnyAuthorityDirect(REPLACE_GERMPLASM_PERMISSIONS);
    }

    showAddNewEntriesAction() {
        return  this.studyEditorContext.germplasmListExists && this.principal.hasAnyAuthorityDirect(ADD_NEW_ENTRIES_PERMISSIONS);
    }

    showImportEntryDetailsAction() {
        return  this.studyEditorContext.germplasmListExists && this.principal.hasAnyAuthorityDirect(IMPORT_ENTRY_DETAILS_PERMISSIONS);
    }

    showSetEntryTypeAction() {
        return  this.studyEditorContext.germplasmListExists && !this.studyEditorContext.hasGeneratedDesign() && this.principal.hasAnyAuthorityDirect(MODIFY_ENTRY_DETAILS_VALUES_PERMISSIONS);
    }

    protected onSelectPage() {
        if (this.isPageSelected()) {
            // remove all items
            this.entries.forEach((item) => this.selectedItems.delete(item.entryId));
        } else {
            // check remaining items
            this.entries.forEach((item) => this.selectedItems.add(item.entryId));
        }
    }

    protected isPageSelected() {
        return this.selectedItems && this.selectedItems.size && this.entries.every((item) => this.selectedItems.has(item.entryId));
    }
}
